import React from "react";
import { motion } from "framer-motion";
import { WhatsAppIcon } from "./icons";
import { waLink } from "../data/content";

export const WhatsAppCta = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-cta"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.6 }}
    whileHover={{ scale: 1.05 }}
    className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-6 py-3.5 shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)]"
  >
    <span className="relative grid place-items-center">
      <span className="absolute inline-flex h-9 w-9 rounded-full bg-white/30 animate-ping" />
      <WhatsAppIcon className="relative h-7 w-7" />
    </span>
    <span className="hidden sm:inline text-sm font-semibold">
      Ask About a Session
    </span>
  </motion.a>
);
